export const userIsInTheLift = ({ id }) => lift => lift.users.some(({ user }) => user.id === id)
